<header class="header" [class.scrolled]="scrolled">
  <div class="top-header">
    <div class="container">
      <div class="row">
        <div class="col">
          <span dir="ltr">Phone: +01011419115</span>
          <span class="emailAddress" dir="ltr">email: support&#64;radwakhallaf.com</span>
        </div>
        <div class="col text-right">
          <div *ngIf="!ifLogin">
            <span style="cursor: pointer" routerLink="/login">{{ 'nav.login' | translate }}</span>
            <span>/</span>
            <span style="cursor: pointer" routerLink="/sign_up">{{ 'nav.register' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <nav class="navbar">
      <!-- Site logo -->
      <a routerLink="/" class="logo">
        <img src="assets/images/Logo ver 1.png" alt="" />
      </a>

      <a
        href="javascript:void(0);"
        [matMenuTriggerFor]="menus"
        id="mobile-menu-toggler"
      >
        <i class="ti-align-justify"></i>
      </a>

      <mat-menu #menus="matMenu" yPosition="below">
        <button routerLinkActive="activebutton" routerLink="/home" mat-menu-item>
          {{ 'nav.home' | translate }}
        </button>
        <button routerLinkActive="activebutton" routerLink="/about" mat-menu-item>
          {{ 'nav.about' | translate }}
        </button>
        <button routerLinkActive="activebutton" routerLink="/categories" mat-menu-item>
          {{ 'nav.categories' | translate }}
        </button>
        <button routerLinkActive="activebutton" routerLink="/packges" mat-menu-item>
          {{ 'nav.packages' | translate }}
        </button>
        <button routerLinkActive="activebutton" routerLink="/shop" mat-menu-item>
          {{ 'nav.shop' | translate }}
        </button>
        <button routerLinkActive="activebutton" routerLink="/blogs" mat-menu-item>
          {{ 'nav.blogs' | translate }}
        </button>
        <button
          *ngIf="showRequestProduct"
          (click)="openDialog()"
          style="cursor: pointer"
          mat-menu-item
        >
          {{ 'nav.request' | translate }}
        </button>
      </mat-menu>

      <ul class="navbar-nav">
        <li><a routerLinkActive="active" routerLink="/home">{{ 'nav.home' | translate }}</a></li>
        <li><a routerLinkActive="active" routerLink="/about">{{ 'nav.about' | translate }}</a></li>
        <li><a routerLinkActive="active" routerLink="/categories">{{ 'nav.categories' | translate }}</a></li>
        <li><a routerLinkActive="active" routerLink="/packges">{{ 'nav.packages' | translate }}</a></li>
        <li><a routerLinkActive="active" routerLink="/shop">{{ 'nav.shop' | translate }}</a></li>
        <li><a routerLinkActive="active" routerLink="/blogs">{{ 'nav.blogs' | translate }}</a></li>
        <li>
          <a *ngIf="showRequestProduct" (click)="openDialog()" style="cursor: pointer">
            {{ 'nav.request' | translate }}
          </a>
        </li>
      </ul>

      <div class="d-inline-flex align-items-center">
        <div *ngIf="ifLogin">
          <span
            style="cursor: pointer"
            [matMenuTriggerFor]="menu"
            class="user-image icon"
          >
            <img src="assets/images/userlogin.png" />
          </span>
          <mat-menu #menu="matMenu" yPosition="below">
            <button routerLink="/user_profile" mat-menu-item>
              <mat-icon>person</mat-icon>
              {{ 'nav.profile' | translate }}
            </button>
            <button mat-menu-item (click)="logout()">
              {{ 'nav.logout' | translate }}
              <mat-icon>logout</mat-icon>
            </button>
          </mat-menu>
        </div>
        <a
          (click)="openDialogSearch()"
          style="cursor: pointer"
          class="search-icon icon"
        >
          <i class="ti-search"></i>
        </a>
        <a class="cart-bag icon">
          <i
            *ngIf="ifLogin"
            style="cursor: pointer"
            routerLink="/shop_cart"
            class="ti-shopping-cart"
          ></i>
          <span *ngIf="showCardNotification" class="itemCount">{{ cardLength }}</span>
        </a>

        <a routerLink="/wishlist" class="wishlist icon" style="cursor:pointer;position:relative;">
          <i class="ti-heart"></i>
          <span *ngIf="wishlistLength > 0" class="itemCount">{{ wishlistLength }}</span>
        </a>

        <button class="lang-toggle" (click)="toggleLang()" [class.is-ar]="currentLang === 'ar'" title="Switch language">
          <span class="lt-en">EN</span>
          <span class="lt-sep">|</span>
          <span class="lt-ar">ع</span>
        </button>
      </div>
    </nav>
  </div>
</header>
